import { makeStyles } from '@material-ui/core';

import { filterBaseStyles } from '../Filters/Filters.styled';

export const useStyles = makeStyles(
  theme => ({
    ...filterBaseStyles(theme),
    selectorsRow: {
      display: 'flex',
      gap: theme.spacing(1),
      alignItems: 'center',
      marginBottom: theme.spacing(1)
    },
    inputWrapper: {
      flex: 1
    }
  }),
  { name: 'TextFilter' }
);
